import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { v4 as uuidv4 } from 'uuid'
import {
  PersonalizeAttributeFormType,
  PersonalizeAttributeType,
  PersonalizeDetailType,
  PersonalizeFormType,
  PersonalizeInitialStateType,
  PersonalizeModeEnum,
  PersonalizeOperatorEnum,
  SetPersonalizationAttributeFormPayloadActionType,
  SetPersonalizationFormPayloadActionType,
} from 'features/CategoryAndPosisi/@types/Personalization'

export const SLICE_NAME_PERSONALIZATION = 'personalization'

export const getPersonalizationFormDefault = (): PersonalizeFormType => ({
  mode: PersonalizeModeEnum.STANDART,
  is_exclusive: false,
  is_open_based: false,
  isActive: false,
  attributes: [],
})

export const getPersonalizationAttributeFormDefault = (): PersonalizeAttributeFormType => ({
  key: uuidv4(),
  attribute: null,
  selectedOperator: PersonalizeOperatorEnum.IN,
  selectedOption: [],
})

const initialState: PersonalizeInitialStateType = {
  personalizationAttributes: [],
  personalizationCurrent: null,
  personalizationForm: getPersonalizationFormDefault(),
}

const slice = createSlice({
  name: SLICE_NAME_PERSONALIZATION,
  initialState,
  reducers: {
    resetState: () => initialState,

    setPersonalizationAttributes: (
      state,
      { payload }: PayloadAction<PersonalizeAttributeType[]>,
    ) => {
      state.personalizationAttributes = [...payload]
    },

    setPersonalizationCurrent: (
      state,
      { payload }: PayloadAction<Nullable<PersonalizeDetailType>>,
    ) => {
      state.personalizationCurrent = payload
    },

    setPersonalizationForm: (
      state,
      { payload }: PayloadAction<SetPersonalizationFormPayloadActionType>,
    ) => {
      const { field, value } = payload
      state.personalizationForm[field] = value as never
    },

    resetPersonalizationForm: (
      state,
      { payload }: PayloadAction<PersonalizeFormType | undefined>,
    ) => {
      state.personalizationForm = payload || { ...getPersonalizationFormDefault() }
    },

    setPersonalizationAttributeForm: (
      state,
      { payload }: PayloadAction<SetPersonalizationAttributeFormPayloadActionType>,
    ) => {
      const { index, field, value } = payload
      state.personalizationForm.attributes[index][field] = value as never
    },

    addPersonalizationAttributeForm: (
      state,
      { payload }: PayloadAction<PersonalizeAttributeFormType | undefined>,
    ) => {
      const personalizationAttributePayload: PersonalizeAttributeFormType = payload || {
        ...getPersonalizationAttributeFormDefault(),
      }

      state.personalizationForm.attributes = [
        ...state.personalizationForm.attributes,
        personalizationAttributePayload,
      ]
    },
  },
})

export const {
  resetState,
  setPersonalizationAttributes,
  setPersonalizationCurrent,
  setPersonalizationForm,
  resetPersonalizationForm,
  setPersonalizationAttributeForm,
  addPersonalizationAttributeForm,
} = slice.actions
export default slice.reducer
